import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";

// Public footer: legal links (texts managed by the restaurant in Admin) + copyright. Matches Mobile.
export function LegalFooter({ name }) {
  const { t } = useI18n();
  const links = [
    { kind: "privacy", label: t("legalPrivacy") },
    { kind: "terms", label: t("legalTerms") },
    { kind: "imprint", label: t("legalImprint") },
  ];
  return (
    <footer className="mt-16 border-t border-hm-line pt-8 pb-4 text-center" data-testid="legal-footer">
      <p className="font-display text-lg text-hm-ink">{name || "Hallo Magic Pizza"}</p>
      <p className="mt-1 font-sans text-xs text-hm-muted">{t("heroTagline")} · Marly</p>
      <div className="mt-3 flex flex-wrap items-center justify-center gap-x-5 gap-y-1" data-testid="legal-links">
        {links.map((l) => (
          <Link
            key={l.kind}
            to={`/legal/${l.kind}`}
            data-testid={`legal-link-${l.kind}`}
            className="py-1 font-sans text-[13px] font-bold text-hm-muted underline underline-offset-2 transition-colors hover:text-hm-ink"
          >
            {l.label}
          </Link>
        ))}
      </div>
      <p className="mt-2 font-sans text-xs text-hm-muted">© {new Date().getFullYear()} {name || "Hallo Magic Pizza"}</p>
    </footer>
  );
}
